import React from 'react';
import clsx from 'clsx';

const Loading = (props) => {
    const { className, style } = props;

    return (
        <div className={clsx('loading-icon', className)} style={style}>
            <div />
            <div />
            <div />
            <div />
        </div>
    );
};

export default Loading;
